<template>
    <div v-if="contrato">
        <form class="form-horizontal" >
            <div class="form-group">
                <div class="col-sm-12">
                    <label class="control-label">NOME DO CLIENTE</label>
                    <input disabled type="text" v-model="contrato.cliente.nome" class="form-control" >
                </div>
            </div>
            <a class="btn btn-success" :href="'#/contrato/usuario/'+ contrato._id">
                <i class="fa fa-plus" aria-hidden="true"></i> NOVO USUÁRIO
            </a><br/><br/>
            <list-usuarios :id="contrato._id"/>
        </form>
    </div>
</template>
<script>
import ListUsuarios from "../../../components/contratos/ListUsuarios.vue";
import contratoMixin from "../../mixins/contrato";
export default {
    components: {
        ListUsuarios
    },
    mixins: [contratoMixin]
};
</script>
